///<reference path="./formsy-react.d.ts" />
///<reference path="./spel2js.d.ts" />

export * from './components';
export * from './layouts';
export * from './FormsyComponent';
import './spel2js.templateParser';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/presentation/formsy/index.ts